import React, { useContext } from 'react';
import { useTranslate } from '@bynder/localization';

import { IconLanguage } from '@bynder/icons';
import { InfoContext } from '../../../context';
import { LanguageItemOLD } from './LanguageItemOLD';
import { iconSizeMedium } from '../../../helpers/iconSizes';

export function LanguageMenuOLD({ isOpen }: { isOpen: boolean }) {
	return <Languages isOpen={isOpen} />;
}

export function LanguageMenuButton({ isOpen }: { isOpen: boolean }) {
	return <Languages isButton isOpen={isOpen} />;
}

function Languages({ isButton, isOpen }: { isButton?: boolean; isOpen?: boolean }) {
	const { languages } = useContext(InfoContext);
	const { translate } = useTranslate();

	return (
		<>
			<a href="#" className="admin-option sub">
				<IconLanguage size={iconSizeMedium} /> {translate('generalLanguage')}
			</a>

			{isOpen && (
				<div className={`admin-dropdown${isButton ? '' : '-sub'}`}>
					<ul className={`single${isButton ? '' : '-sub'}`}>
						{languages.available.map((language) => {
							const isActive = language.locale === languages.selected;

							return (
								<LanguageItemOLD
									key={language.locale}
									className={isActive ? 'active' : ''}
									locale={language.locale}
									localeFullName={language.display_name}
									isActive={isActive}
								/>
							);
						})}
					</ul>
				</div>
			)}
		</>
	);
}
